import React from 'react'

import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { useTranslationRankmi } from 'helpers/translations.helper'

import { ModalBodyText } from './styled'

interface ConfirmNormativeCourseEditModalProps {
  isOpen: boolean
  processing?: boolean
  onClose: () => void
  onConfirmAndUpdate: () => void
}

export const ConfirmNormativeCourseEditModal: React.FC<ConfirmNormativeCourseEditModalProps> =
  ({ isOpen, processing = false, onClose, onConfirmAndUpdate }) => {
    const t = useTranslationRankmi({
      prefix: 'administration.courses.edit.confirmNormativeModal',
    })

    return (
      <Modal
        isOpen={isOpen}
        title={t('title')}
        isConfirmation
        maxwidth={800}
        maxheight={260}
        close={onClose}
        actions={
          <ModalButtons
            secondaryText={t('cancel')}
            secondaryAction={onClose}
            disableSecondaryButton={processing}
            primaryText={t('confirmAndUpdate')}
            primaryAction={onConfirmAndUpdate}
            disablePrimaryButton={processing}
            processing={processing}
          />
        }
      >
        <ModalBodyText>
          {t('bodyBeforeName')}
          <strong>{t('bodyName')}</strong>
          {t('bodyBeforeDuration')}
          <strong>{t('bodyDuration')}</strong>
          {t('bodyAfter')}
        </ModalBodyText>
      </Modal>
    )
  }

export default ConfirmNormativeCourseEditModal
